<template>
    <div>
        <Header></Header>
        <div class="content col-12 mt-4">

		
            <p>
            Gizlilik
            Politikası</p>
            
            
            
            <p>Bu
            Gizlilik Politikası (“Politika”), Minimum CRM’i kullanımınız
            sırasında nasıl bilgi topladığımızı ve kullandığımızı
            açıklığa kavuşturmayı amaçlar.</p>
            
            
            
            <ul><li>
                <strong>Tanımlar</strong>
            </li></ul>
            
            
            
            <p>“Müşteri”,
            Minimum CRM müşterisi anlamına gelir.</p>
            
            
            
            <p>“Müşteri
            Verileri”, bir Kullanıcı’nın Minimum CRM içinde depoladığı
            kişisel veriler, notlar, raporlar, adresler ve diğer belgeler
            anlamına gelir.</p>
            
            
            
            <p>
            “Kişisel
            Veriler”, tanımlanmış veya tanımlanabilir bir gerçek kişi
            ile ilgili herhangi bir bilgi anlamına gelir.</p>
            
            
            
            <p>“Siz”
            veya “Kullanıcı”, Minimum CRM’in sunduğu hizmetlere
            erişmek amacıyla Minimum CRM’i kullanan bir Müşteri veya
            müşterinin temsilcisi anlamına gelir.</p>
            
            
            
            <p>“Ziyaretçi”,
            Minimum CRM’in herkesin erişimine açık alanlarına erişimi olan
            Kullanıcı dışındaki bir kişi anlamına gelir.</p>
            
            
            
            <p>
            “Entegre
            Hizmet”, üçüncü kişilerce sağlanan, bu hizmetlerin kullanıcı
            adı ve şifrelerini kullanarak Minimum CRM’e bağlanma imkânı
            veren hizmetler anlamına gelir.</p>
            
            
            
            <ul><li>
                <strong>Sorumluluklar
                ve Onay</strong>
            </li></ul>
            
            
            
            <p>
            Minimum
            CRM’de depoladığınız bilgiler sizindir. İçerikleriyle
            ilgilenmez, size hizmet sunmak dışında bir amaçla izniniz olmadan
            kullanmayız ve asla başkalarına satmayız. Eğer Avrupa Birliği
            sınırları içinde yerleşikseniz, Minimum CRM’e yüklediğiniz her
            türlü “Kişisel Veriler”iniz kapsamında Avrupa Birliği Genel
            Veri Koruma Yönetmeliği’nce (bundan böyle “GDPR” olarak
            anılacaktır) tanımlanan “Veri İşleyicisi” sorumluluğu
            taşımaktayız. Bu bilgileri, istediğiniz zaman değiştirebilir,
            silebilir, bunlara erişim yetkilerini uygun bulduğunuz şekilde
            düzenleyebilir ve yönetebilirsiniz. Minimum CRM’de depoladığınız
            bilgilerin kontrolü tamamen sizdedir. Bu nedenle Minimum CRM,
            Müşteri Verisi içinde yer alan herhangi bir Kişisel Verinin
            toplanması ve kullanımı konusunda Avrupa Birliği Genel Veri
            Koruma Yönetmeliği’nce (bundan böyle “GDPR” olarak
            anılacaktır) tanımlanan “Veri Sorumlusu” yükümlülük ve
            sorumluluklarına sahip değildir. Minimum CRM kullanımıyla ilgili
            destek ihtiyacınız olduğunda size yardımcı olmak için elimizden
            gelen çabayı sarf ederiz. Ancak verilerinizin gizliliğini sağlamak
            için aldığımız önlemler nedeniyle, destek ekibimiz kayıtlı
            bilgilerinize ulaşamayabilir ve tarif ettiğiniz sorunu
            gözlemleyemeyebilir. Bu durumlarda dahi erişim şifrelerinizi
            destek personelimizle paylaşmamalı ve tüm sorumluluk sizde olmak
            üzere, sadece sorununuzu tarif etmeye yeterli olacak kadar bilgi ve
            ekran görüntüsü paylaşmalısınız. Herhangi bir nedenle destek
            hizmetleri almak amacıyla bir personelimize, sizin hesabınıza
            erişmesi için izin verdiğinizde, Kişisel Verilerinizin koruma
            altında olmasından sorumlu olursunuz. Aralarında web sitemiz,
            mobil arayüzler, istemciler, üçüncü parti sağlayıcılar ve web
            siteleri, API, SMS, e-posta ve diğer iletişim kanalları da bulunan
            çeşitli kaynaklardan bilgi topluyoruz. Minimum CRM’e kaydolarak,
            Kullanım Koşulları ve bu Politikadaki hükümler dahilinde bu
            bilgileri işlememize, kaydetmemize, açıklamamıza, ve diğer
            şekillerde kullanmamıza izin vermiş oluyorsunuz.</p>
            
            
            
            <ul><li>
                <strong>Hangi
                Bilgileri Topluyoruz?</strong>
            </li><li>
                    <strong>Sizin
                    Tarafınızdan Sağlanan Bilgiler</strong>
                </li></ul>
            
            
            
            <p>
            Minimum
            CRM’i, Kullanıcı veya Ziyaretçi olarak kullandığınızda,
            Kişisel Veriler toplayabiliriz. Bunlar aşağıdaki bilgileri
            içerebilir: Kişisel kayıt bilgileri: Kullanıcı olarak Minimum
            CRM’e kaydolduğunuz zaman, siz, şirketiniz ve çalışma
            arkadaşlarınız hakkında bazı bilgiler sağlayabilirsiniz. Bunlar
            isimler, pozisyonlar, telefon numaraları, e-posta adresleri, meslek,
            dil ve diğer bilgiler içerebilir. Kullanıcı adları ve şifreler:
            Kendinizi kullanıcı olarak Minimum CRM’e tanıtmak için bir
            kullanıcı adı ve şifre seçersiniz. Bu bilgiler, kişisel
            hesabınızla ilişkilendirilir. Şirket bilgileri: Minimum CRM,
            şirketiniz hakkında endüstri, organizasyon yapısı, çalışanlar,
            iş hacmi, konumları da içeren bilgiler vermenizi isteyebilir.
            Başkaları hakkında bilgiler: Minimum CRM kullanılırken, Minimum
            CRM kullanıcısı olan veya olmayan başkaları hakkında bilgiler
            girilebilir ve bunlar bazı işlevleri sağlamak için
            kaydedilebilir. Bunlar arasında Müşterilerin müşterileri,
            tedarikçileri, hizmet sağlayıcıları, irtibatta olunan kişiler
            ve başkaları olabilir. Veri: Kullanıcılar, aralarında toplantı
            notları, yorumlar, projeler, planlanmış olaylar, aktiviteler,
            bağlantılar ve diğerlerinin de bulunduğu çeşitli veri türlerini
            Minimum CRM’e girebilirler. Konum: Bazen Minimum CRM konum bilgisi
            sorabilir veya bu bilgiyi girme imkanı tanıyabilir. Ayrıca sizin
            network adresiniz veya Minimum CRM’e erişmek için kullandığınız
            istemciler veya servis sağlayıcılar tarafından sağlanan
            bilgilerle de konumunuzu belirleyebiliriz. Sosyal ağ bağlantıları:
            Siz veya başkaları hakkında girdiğiniz bazı bilgiler, sosyal ağ
            profilleri ve verilerinin belirlenmesinde kullanılabilir.
            Bağlantılar: Minimum CRM’e harici ve dahili web linkleri
            girebilirsiniz. Minimum CRM hizmetlerini kullanarak, toplanan tüm
            bilgilerin Hizmet Koşulları ve bu Gizlilik Politikası’na uygun
            olarak kullanılmasına rıza göstermiş olursunuz.</p>
            
            
            
            <ul><li>
                    <strong>Sizin
                    Tarafınızdan Toplanan Bilgiler</strong>
                </li></ul>
            
            
            
            <p>
            Minimum
            CRM kullanımı sırasında, müşterileriniz ve kullanıcılarına
            ait farklı bilgileri toplayabilirsiniz. Minimum CRM’de depoladığınız
            bilgilerin toplanması, kullanımı, silinmesiyle ilgili konular,
            yasalar ve yönetmelikler çerçevesinde sizin sorumluluğunuzdadır.</p>
            
            
            
            <ul><li>
                    <strong>Otomatik
                    Olarak Toplanan Bilgiler</strong>
                </li></ul>
            
            
            
            <p>
            Minimum
            CRM kullanırken, çerezler de dahil olmak üzere çeşitli
            teknolojileri kullanarak, cihazınızdan belirli bilgileri otomatik
            olarak kaydedebiliriz. Cookie’ler web tarayıcılarının
            cihazlarınıza kaydettiği küçük veri dosyalarıdır. Hem oturum,
            hem de kalıcı cookie’leri, hizmet kullanımını izlemek ve bazı
            işlevleri sunmak için kullanabiliriz. Tüm çevrimiçi faaliyetleri
            ve kullanımları, zamanları, veri transferlerini, IP adresleri
            dahil olmak üzere kaydedebiliriz.</p>
            
            
            
            <ul><li>
                    <strong>Entegre
                    Hizmetler Aracılığıyla Elde Edilen Bilgiler</strong>
                </li></ul>
            
            
            
            <p>
            Depolama,
            bulundurma, reklam yayını da dahil ancak bunlarla sınırlı
            olmamak üzere, hizmetin bazı kısımları iş ortaklarımız ve
            üçüncü partilerce sağlanabilir. Onların hizmetlerinden
            faydalandığımızda, bilgilerinizin kullanımı bu Politikada
            belirtilen korumalara aynen tabidir. Üçüncü kişilerce sağlanan
            (Google hesabınızla bağlanmak gibi) belirli hizmetlerin kullanıcı
            adı ve şifresini kullanarak Minimum CRM’e erişme veya kaydolma
            seçeneği verilebilir veya diğer bilgileri Minimum CRM’e sağlamak
            için bir Entegre Hizmeti yetkilendirme seçeneği kullanılabilir.
            Bu tür hizmetleri kullanarak Minimum CRM’e bağlanmadan önce lütfen
            her Entegre Hizmet sağlayıcısının yayımladığı kullanım
            koşullarını ve gizlilik politikalarını dikkatle gözden geçirin.</p>
            
            
            
            <ul><li>
                    <strong>Diğer
                    Kaynaklardan Toplanan Bilgiler</strong>
                </li></ul>
            
            
            
            <p>
            Kişisel
            Veriler de dahil olmak üzere, üçüncü kişilerden ve iş
            ortaklarından, reklam verenler ve Entegre Hizmetler gibi Minimum CRM
            dışındaki kaynaklardan bilgi edinebiliriz. Topladığımız
            bilgileri daha iyi hedeflenmiş, ilgili içerik ve hizmetleri
            yayınlamak için kullanabiliriz. Bunları yayınlamak için üçüncü
            kişilerin hizmetlerini kullandığımızda, kişisel olarak
            tanımlanmanıza yol açacak bilgileri açığa çıkarmadığımızdan
            emin oluruz ve Kişisel Bilgileri bu Politikaya uygun olarak ele
            alırız.</p>
            
            
            
            <ul><li>
                <strong>Topladığımız
                Bilgileri Nasıl Kullanıyoruz?</strong>
            </li></ul>
            
            
            
            <p>
            Minimum
            CRM’in sunduğu hizmetlerin sürekliliği için topladığımız
            bilgileri aşağıdaki amaçlar için kullanıyoruz:</p>
            
            
            
            <ul><li>
                    <strong>İşleyişimizi
                    İyileştirmek</strong>
                </li></ul>
            
            
            
            <p>
            Minimum
            CRM’in sunduğu hizmetleri geliştirmek, yeni özellikler ve ürünler
            sunmak, işlevselliği artırmak, ihtiyaçlarınızı anlamak,
            isteklerine daha hızlı cevap verebilmek ve iletişimimizi
            geliştirerek daha iyi hizmet vermek, ürün ve hizmetlerimizi
            geliştirmek ve çeşitlendirmek, raporlama ve sair
            yükümlülüklerimizi yerine getirebilmek gibi amaçlar için
            Kişisel Verileriniz depolanabilir, işlenebilir. Bu hizmet üçüncü
            kişilerden alınabilir.</p>
            
            
            
            <ul><li>
                    <strong>İletişim
                    Kurmak</strong>
                </li></ul>
            
            
            
            <p>
            E-posta
            adresi ve iletişim bilgilerinizi iletişim kurmak, destek hizmetleri
            sağlamak ve sunduğumuz ürün ve hizmetlerle ilgili bilgi sağlamak
            amacıyla kullanabiliriz. Size bu tür iletişimlerden ayrılma
            hakkını sağlarız.</p>
            
            
            
            <ul><li>
                    <strong>Özelleştirilmiş
                    Hizmetler Sunmak ve Ziyaret Analizleri Sağlamak</strong>
                </li></ul>
            
            
            
            <p>
            Çerezleri
            kullanarak Minimum CRM kullanımınız sırasında bazı bilgileri
            yeniden girmek zorunda kalmazsınız. Ayrıca sunduğumuz hizmetleri
            kişiselleştirmek, özelleştirilmiş reklamlar, içerik ve bilgi
            sağlamak, kullanım eğilimlerini ve alışkanlıklarını ölçmek
            amacıyla bu bilgileri kullanabiliriz.</p>
            
            
            
            <ul><li>
                <strong>Bilgilerin
                Paylaşımı</strong>
            </li><li>
                    <strong>Başkalarıyla
                    Paylaştığınız Bilgiler</strong>
                </li></ul>
            
            
            
            <p>
            Minimum
            CRM bir bilgi paylaşım ortamıdır. Paylaşılmış dosyalar,
            irtibatta olduğunuz kişiler, yorumlar ve diğer verileriniz de
            dahil olmak üzere paylaştığınız bilgiler, sizin tercihleriniz
            doğrultusunda başkalarına sunulacaktır. Kullanımınıza sunulan
            yetkilendirme seçenekleri gibi çeşitli ayarların başkalarıyla
            paylaşımınızı nasıl etkilediğini anladığınızdan emin
            olmalısınız.</p>
            
            
            
            <ul><li>
                    <strong>Servis
                    Sağlayıcılar</strong>
                </li></ul>
            
            
            
            <p>
            Depolama,
            bulundurma, reklam yayını, web sitesi analitiği de dahil ancak
            bunlarla sınırlı olmamak üzere, hizmetin bazı kısımları iş
            ortaklarımız ve üçüncü kişilerce sağlanabilir. Onların
            hizmetlerinden faydalandığımızda, bilgilerinizin kullanımı bu
            politikada belirtilen korumalara aynen tabidir.</p>
            
            
            
            <ul><li>
                    <strong>Yasal
                    Açıklama ve Başkalarına Zararın Önlenmesi</strong>
                </li></ul>
            
            
            
            <p>
            Çalıştığımız
            ülkelerin kanun ve kurallarına saygı gösteririz ve bir kanun
            kuvvetinden haklı bir talep geldiğinde bilgileri teslim edebiliriz.
            Yasa dışı veya başkalarına zarar verebilecek bir faaliyet
            yürütmekte olduğunuza dair yeterince kuşkumuz varsa, bilgileri
            kanun kuvvetlerine teslim edebiliriz.</p>
            
            
            
            <ul><li>
                    <strong>Mülkiyet
                    Değişimi</strong>
                </li></ul>
            
            
            
            <p>
            Minimum
            CRM bir bilgi paylaşım ortamıdır. Paylaşılmış dosyalar,
            irtibatta olduğunuz kişiler, yorumlar ve diğer verileriniz de
            dahil olmak üzere paylaştığınız bilgiler, sizin tercihleriniz
            doğrultusunda başkalarına sunulacaktır. satılır, satın alınır,
            veya herhangi bir biçimde el değiştirirse, bilgileriniz de aynı
            işlemin parçası olarak yeni sahibine devredilir. Bu Politikada
            belirtilen koşullar bu durumda yeni sahibini aynen bağlar.</p>
            
            
            
            <ul><li>
                <strong>Veri
                Güvenliği</strong>
            </li></ul>
            
            
            
            <p>
            Bilgilerinizi
            Minimum CRM bir bilgi paylaşım ortamıdır. Paylaşılmış
            dosyalar, irtibatta olduğunuz kişiler, yorumlar ve diğer
            verileriniz de dahil olmak üzere paylaştığınız bilgiler, sizin
            tercihleriniz doğrultusunda başkalarına sunulacaktır.’de
            depoladığınızda ilettiğiniz bilgileri korumak için genel kabul
            görmüş endüstri standartlarını takip ederiz. Bu kapsamda
            Kişisel Verilere, kanuna aykırı olan tüm yetkisiz kullanımlar,
            erişimler ve kötüye kullanmalara karşı korumak için makul
            teknik önlemleri alırız. Ayrıca, verilerinize etkide
            bulunabilecek herhangi bir veri güvenliği ihlalinde sizi,
            yürürlükteki yasalara uygun olarak bilgilendiririz.</p>
            
            
            
            <ul><li>
                <strong>Haklarınız</strong>
            </li></ul>
            
            
            
            <p>
            Verilerinizle
            ilgili oluşabilecek taleplerinizi aldıktan sonra, kendi iç
            prosedürlerimizi de dikkate alarak talebinizin yerine getirilmesi
            için çalışmaya başlarız ve bu konuda yürürlükteki yasalar
            kapsamında sizi bilgilendiririz. Tüm başvurulara 30 gün içinde
            cevap veririz.</p>
            
            
            
            <ul><li>
                <strong>Gizlilik
                Politikası Değişiklikleri ve Güncellemeler</strong>
            </li></ul>
            
            
            
            <p>
            Bu
            Politikayı herhangi bir anda önceden haber vermeksizin
            değiştirebiliriz. Bazı durumlarda önemli değişiklikleri size
            e-posta veya web sitesi duyuruları ile bildirebiliriz, ancak buna
            zorunlu değiliz. Politikanın güncel şartlarını her zaman web
            sitemizde “Gizlilik” sayfasından okuyabilirsiniz. Politikayı
            değiştirdiğimiz zaman, en son revizyon tarihini burada
            belirteceğiz.</p>
            
            
            
            <ul><li>
                <strong>Bize
                Nasıl Ulaşabilirsiniz</strong>
            </li></ul>
            
            
            
            <p>
            Bu
            Politikaya dair, Kişisel Bilgilerin kullanımıyla ilgili
            sorularınız, yorumlarınız veya Kişisel Bilgilerinizle ilgili
            oluşabilecek herhangi bir sorun ya da şikayetiniz için
            destek@hermesiletisim.net adresine e-posta göndererek iletişime
            geçebilirsiniz.</p>
            
                
        </div>
    </div>
</template>
<script>
import Vue from 'vue'
import Header from './header'
import axios from 'axios'
export default {
    name:"privacyPolicy",
    data () {
        return {
        }
    },
    components:{
        Header
    },
    computed:{
    },
}
</script>

<style scoped>
</style>